export default __webpack_public_path__ + "static/media/adhyanshala_footer_logo_last.d6007d22.png";